/* eslint-disable radix */
import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { authContext } from 'contexts/AuthContext';
import { DELETE_MULTI_VENDORS } from 'pages/Vendor/VendorGraphQL';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { RiDeleteBin7Line } from 'react-icons/ri';

const DeleteVendorList = ({ rowSelection, resetRowSelection }) => {
  const { auth } = useContext(authContext);
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  // const [deleteTraderIds, setDeleteTradersIds] = useState(
  //   Object.keys(rowSelection) || []
  // );

  const toggleDeleteRecord = () => {
    setDeleteRecord(!showDeleteRecord);
  };
  const [deleteTraders] = useMutation(DELETE_MULTI_VENDORS, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success('Selected user deleted successfully');
      toggleDeleteRecord();
      resetRowSelection();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      toggleDeleteRecord();
      resetRowSelection();
    },
  });

  const onDeleteConfirmation = async () => {
    try {
      await deleteTraders({
        variables: {
          ids: rowSelection?.map((key) => parseInt(key)),
          deletedFrom: 'Admin',
          deletedBy: auth?.data?.userId,
        },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <>
      {' '}
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
      <Button
        size="sm"
        className="small-btn"
        color="light"
        onClick={toggleDeleteRecord}
        disabled={rowSelection.length === 0}
      >
        <RiDeleteBin7Line size={12} style={{ marginTop: '-2px' }} /> Delete
      </Button>
    </>
  );
};

export default DeleteVendorList;
